var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "#255056",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeDasharray: "4 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.cf1575d167521a59dde5f0ce64b392b9.svg";
export { ForwardRef as ReactComponent };